<template>
  <validation-observer v-slot="{ valid }">
    <validation-helper :interceptor="valid" @isValid="$emit('fourthStepAvailable', $event)" />

    <v-row class="mx-auto">
      <v-col id="saneamento-voc-aplicar-caderno-servicos" cols="12" class="pl-2 pt-0">
        <v-checkbox
          label="Aplicar Caderno de Serviços nas obras" 
          v-model="_campos.aplicarCadernoServicos"
        />
      </v-col>
    </v-row>

    <template v-if="_campos.aplicarCadernoServicos === true">
      <saneamento-voc-choose-paramentros-com-ca
        divId="saneamento-caderno-servicos"
        titulo="Caderno de Materiais e Serviços"
        nomeParametro="Caderno de Serviços"
        :items="cadernosServicosExistentes"
        :campos.sync="_campos"
        linkCadastros="/parametros-com-ca/cadernos-servicos"
        parametro="cadernoServico"
      >
        <template v-if="_campos.cadernoServico.origem === 'novo'" v-slot:after-title>
          <v-alert dense outlined type="info" color="blue" class="pa-2">
            <a href="javascript:void(0)" @click="baixarCadernoServicoPadrao()">Clique aqui</a> para baixar o Caderno de Serviços no modelo do sistema, de acordo com os filtros selecionados anteriormente
          </v-alert>
        </template>
      </saneamento-voc-choose-paramentros-com-ca>

      <v-row id="saneamento-voc-percentuais-padroes" class="mx-auto">
        <v-col cols="12">
          <span style="color: rgba(0, 0, 0, 0.54); font-size:15px;">Percentuais Padrão</span> 
        </v-col>

        <v-col
          v-for="(campoPercentual, _key) in _campos.camposPercentuaisPadroes" 
          cols="6" sm="4" :key="_key"
        >
          <v-text-field
            :label="campoPercentual.label"
            type="number" min="0" max="1" step="0.1"
            hint="Valor entre 0 (0%) e 1 (100%)"
            outlined
            v-model="campoPercentual.value"
            @blur="
              (campoPercentual.value > 1) ? campoPercentual.value = 1 : true;
              (campoPercentual.value < 0) ? campoPercentual.value = 0 : true;
            "
          />
        </v-col>
      </v-row>
    </template>
  </validation-observer>
</template>

<script>

import CadernosServicosService from "@/services/parametrosComCa/CadernosServicosService.js";
import dayjs from "dayjs";

export default {
  name: "SaneamentoVocThirdWizardTab",

  components: {
    ValidationHelper: () => import("@/components/general/ValidationHelper.vue"),
    ParametrosArquivoCsv: () => import("@/components/general/GeneralParametrosArquivoCsv.vue"),
    SaneamentoVocChooseParamentrosComCa: () => import("@/components/saneamentoVoc/SaneamentoVocChooseParamentrosComCa.vue"),
  },

  props: {
    campos: {
      type: Object,
      required: true
    },
    cadernosServicosExistentes: {
      type: Array,
      required: true
    },
    filtros: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      processandoArquivoModelo: false,
    }
  },

  computed: {
    _campos: {
      get() {
        return this.campos;
      },
      set(newValues) {
        this.$emit("update:campos", newValues);
      }
    },
  },

  methods: {
    baixarCadernoServicoPadrao() {
      this.$toast.info("Seu arquivo será gerado em breve, por favor aguarde", "", { position: "topRight", timeout: 5000 });

      if (this.processandoArquivoModelo) return;

      this.processandoArquivoModelo = true;

      CadernosServicosService.baixarArquivoPadrao(this.filtros)
        .then(res => {
          let url = window.URL.createObjectURL(new Blob([res.data]));
          let link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", `Caderno_de_Serviços_${dayjs().format("YYYYMMDDHHmmss")}.xlsx`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          console.error('Erro ao baixar Caderno de Serviços padrão: ', err);
          this.$toast.error('Erro ao baixar Caderno de Serviços padrão.', '', { position: 'topRight' });
        })
        .finally(() => this.processandoArquivoModelo = false);
    },
  }
}

</script>

<style>

</style>